var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcFilterChat({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 3.66666H12V4.66666H2V3.66666ZM4.25 6.83334H9.75V7.83334H4.25V6.83334ZM5.75 10H8.25V11H5.75V10ZM0.5 0.5H13.5V1.5H0.5V0.5Z",
    fill: "#00A9FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFilterChat);
export default __webpack_public_path__ + "static/media/ic_filter_chat.1b0906a92458592f2d8e7685b0b8682b.svg";
export { ForwardRef as ReactComponent };